import { Directive, OnInit, TemplateRef, inject } from '@angular/core';
import { BoschUiDialog } from '../bosch-ui-dialog.service';

@Directive({
  selector: '[boschUiDialogBody]',
})
export class BoschUiDialogBodyDirective implements OnInit {
  private readonly template = inject(TemplateRef<unknown>);
  private readonly dialogService = inject(BoschUiDialog);

  ngOnInit(): void {
    const dialog = this.dialogService.dialogRef?.instance;
    if (dialog && dialog.body) {
      dialog.body.createEmbeddedView(this.template);
    }
  }
}
